<template>
    <b-container class="acc-booking-email-template-detail" v-if="!!emailTemplate">
        <b-row>
            <b-col>
                <b-form-group :label="$t('admin_notification_template.type')"
                              horizontal>
                    <b-form-input readonly :value="$t('email_template_types.' + emailTemplate.type)"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group horizontal>
                    <b-form-checkbox v-model="emailTemplate.email_enabled">{{$t('admin_notification_template.email_enabled')}}</b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group :label="$t('admin_notification_template.email_subject')"
                              horizontal>
                    <b-form-input v-model="emailTemplate.email_subject"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group :label="$t('admin_notification_template.email_content')"
                              horizontal>
                    <TinyMceEditor v-model="emailTemplate.email_content" :custom-templates="templates" allow-all-style></TinyMceEditor>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group horizontal>
                    <b-form-checkbox v-model="emailTemplate.push_notification_enabled">{{$t('admin_notification_template.push_notification_enabled')}}</b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group :label="$t('admin_notification_template.push_notification_content')"
                              horizontal
                              v-if="emailTemplate.push_notification_enabled">
                    <b-form-input v-model="emailTemplate.push_notification_content"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-center">
                <b-button @click="saveEmailTemplate">{{$t('save')}}</b-button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import TinyMceEditor from "../../../components/TinyMceEditor";

    export default {
        name: 'AccBookingEmailTemplateDetail',
        components: {TinyMceEditor},
        data() {
            return {
                templateType: this.$route.params.templateType,
                templateId: this.$route.params.templateId,
                emailTemplate: null,
                requiredFields: {
                    email_verification: [],
                    reset_password: [],
                    id_verification_success: [],
                    id_verification_fail: [],
                    id_verification_remind: [],
                },
                templates: [
                    // {title: 'User Name (Chinese)', description: '', content: '{{user_name_zh}}'},
                    // {title: 'User Name (English)', description: '', content: '{{user_name_en}}'},
                    {title: 'Booking Description', description: '', content: '{{booking_description}}'},
                    {title: 'Booking Price', description: '', content: '{{price}}'},
                ]
            }
        },
        mounted() {
            this.getEmailTemplate();
        },
        computed: {},
        methods: {
            getEmailTemplate() {
                this.$callAPI('aafb/admin/email_template/', {id: this.templateId}, function (response) {
                    this.emailTemplate = response.body.template;
                });
            },
            saveEmailTemplate() {
                this.$callAPI('aafb/admin/email_template/set/', {
                    id: this.templateId,
                    email_enabled: this.emailTemplate.email_enabled,
                    email_subject: this.emailTemplate.email_subject,
                    email_content: this.emailTemplate.email_content,
                    push_notification_enabled: this.emailTemplate.push_notification_enabled,
                    push_notification_content: this.emailTemplate.push_notification_content,
                }, function (response) {
                    this.$router.push({name: 'acc-email-template'});
                    this.$showAlertMessage('Info Saved');
                    // this.getEmailTemplate();
                })
            },
        },
    }
</script>

<style scoped lang="less">

</style>
